import { Capacitor } from '@capacitor/core';
import User from 'root-js/models/User';
import router from 'root-js/routes.js';
import { getDeviceInfo } from 'root-js/utils/deviceInfo';

// Ensure the module is namespaced
const namespaced = true;

/*
 *|-----------------------------------------------------------------------------
 *| State
 *|-----------------------------------------------------------------------------
 */
const state = {
    token: localStorage.getItem('token') || null,
    refreshToken: localStorage.getItem('refreshToken') || null,
    apnsToken: localStorage.getItem('apnsToken') || null,
    device: localStorage.getItem('device') || null,
    os: Capacitor.getPlatform(),
    justLoggedIn: false
};

/*
 *|-----------------------------------------------------------------------------
 *| Getters
 *|-----------------------------------------------------------------------------
 */
const getters = {

    /**
     * Determine if the user is authenticated.
     *
     * @param {object} state
     * @returns {boolean}
     */
    isAuthenticated: state => !!state.token,
    device: state => state.device,
    os: state => state.os,
    token: state => state.token,
    apnsToken: state => state.apnsToken,
    justLoggedIn: state => state.justLoggedIn
};

/*
 *|-----------------------------------------------------------------------------
 *| Mutations
 *|-----------------------------------------------------------------------------
 */
const mutations = {
    SET_AUTH: (state, payload) => {
        localStorage.setItem('token', payload.token);
        localStorage.setItem('refreshToken', payload.refresh_token);


        state.token = payload.token;
        state.refreshToken = payload.refresh_token;
    },

    SET_DEVICE: (state, identifier) => {
        state.device = identifier;
    },
    SET_APNS_TOKEN: (state, token) => {
        localStorage.setItem('apnsToken', token);
        state.apnsToken = token;
    },
    SET_JUST_LOGGED_IN: (state, value) => {
        state.justLoggedIn = value;
    },
    UNSET_AUTH: state => {
        state.token = null;
        state.refreshToken = null;
    }
};

/*
 *|-----------------------------------------------------------------------------
 *| Actions
 *|-----------------------------------------------------------------------------
 */
const actions = {
    SET_DEVICE: ({ commit }, identifier) => {
        localStorage.setItem('device', identifier);

        commit('SET_DEVICE', identifier);
    },
    UNSET_AUTH: async ({ commit }) => {
        try {
            await window.api.call('delete-auth', {}, null, {}, false, true);
        } catch (error) {
            console.error('Error during unset authentication:', error);
        } finally {
            commit('UNSET_AUTH');
            localStorage.removeItem('token');
            localStorage.removeItem('refreshToken');
            localStorage.removeItem('referralCode');
            localStorage.removeItem('apnsToken');
            sessionStorage.clear();

            // Remove all user related data
            commit('user/UNSET_USER', null, { root: true });
            commit('boxes/RESET_STATE', null, { root: true });
            commit('payments/RESET_STATE', null, { root: true });
            commit('addresses/RESET_STATE', null, { root: true });
            commit('store/RESET_STATE', null, { root: true });

        }
    },
    LOGOUT({ commit }) {
        localStorage.removeItem('token');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('referralCode');
        localStorage.removeItem('apnsToken');
        

        // Remove all user related data
        commit('user/UNSET_USER', null, { root: true });
        commit('boxes/RESET_STATE', null, { root: true });
        commit('payments/RESET_STATE', null, { root: true });
        commit('addresses/RESET_STATE', null, { root: true });
        commit('store/RESET_STATE', null, { root: true });

        commit('UNSET_AUTH');
        router.replace({ name: 'Welcome' });
    },
    REFRESH_TOKEN: async ({ commit, state, dispatch }) => {
        const freshRefreshToken = localStorage.getItem('refreshToken');
        try {
            const response = await window.api.call('refresh-auth', {
                refresh_token: freshRefreshToken,
                device_info: getDeviceInfo()
            }, null, { timeout: 10000 }, false, true);

            commit('SET_AUTH', response.data.data);
            return response.data.data;
        } catch (error) {
            console.error('Error during refresh token:', error);
            throw error;
        }
    }
};

export default {
    namespaced,
    state,
    mutations,
    actions,
    getters
};
